module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvZm9udHMvU2NyYXRjaC5iYmMwZGQ3LnR0ZiI7"


//////////////////
// WEBPACK FOOTER
// ./node_modules/base64-loader!./node_modules/scratch-render-fonts/src/Scratch.ttf
// module id = +2Yi
// module chunks = 0